import * as Cookies from 'js-cookie';
import isEmpty from 'utils/core/isEmpty';

const getNewRecentlyViewedCookieValue = (recentlyViewedProducts, productCode, recentlyViewedLimit) => {
  if (isEmpty(recentlyViewedProducts)) {
    return productCode;
  }

  const newRecentlyViewedArray = recentlyViewedProducts
    .split(',')
    .filter((recentlyViewedProduct) => recentlyViewedProduct !== productCode)
    .concat(productCode);

  if (newRecentlyViewedArray.length > recentlyViewedLimit) {
    newRecentlyViewedArray.shift();
  }

  return newRecentlyViewedArray.join(',');
};

const setRecentlyViewedCookie = (recentlyViewedCookie) =>
  Cookies.set('recentlyViewed', recentlyViewedCookie, {
    expires: 100,
    path: '/'
  });

const getRecentlyViewedCookie = () => Cookies.get('recentlyViewed');

const recentlyViewed = () => {
  const productDetails = document.getElementById('product_details');

  const { baseProductCode } = productDetails.dataset;
  const { recentlyViewedLimit } = productDetails.dataset;

  const newRecentlyViewedCookieValue = getNewRecentlyViewedCookieValue(
    getRecentlyViewedCookie(),
    baseProductCode,
    recentlyViewedLimit
  );

  return baseProductCode && setRecentlyViewedCookie(newRecentlyViewedCookieValue);
};

export default recentlyViewed;
